import { module } from 'modujs'

export default class extends module {
  constructor(m) {
    super(m)

    this.events = { click: {
      clickedPrev: 'clickedPrev',
      clickedNext: 'clickedNext',
      clickedTitle: 'clickedTitle'
    } }
  }

  init() {
    this.prevBtn = this.el.querySelector('.c-button.is-back')
    this.nextBtn = this.el.querySelector('.c-button.is-next')
    this.titlesWrapper = this.el.querySelector('.testimonies__content__data__titles')

    this.onFocusInTitlesWrapper = this.onFocusInTitlesWrapper.bind(this)
    this.onFocusOutTitlesWrapper = this.onFocusOutTitlesWrapper.bind(this)

    this.testimonies = this.getTestimonies()

    this.titlesWrapper.addEventListener('focusin', this.onFocusInTitlesWrapper)
    this.titlesWrapper.addEventListener('focusout', this.onFocusOutTitlesWrapper)

    this.isTransitioning = false
    this.currentIndex = 0
    this.currentTransitionEndCallback = null

    this.ro = new ResizeObserver(() => {
      this.refreshTitleOffset()
    })

    this.ro.observe(this.titlesWrapper)
  }

  onFocusInTitlesWrapper(e) {
    const indexOfTarget = this.testimonies.findIndex(testimony => testimony.title === e.target)

    if (indexOfTarget !== -1)
      this.refreshTitleOffset(indexOfTarget)
  }

  onFocusOutTitlesWrapper() {
    this.refreshTitleOffset()
  }

  getTestimonies() {
    const medias = this.el.querySelectorAll('.testimonies__content__media')
    const titles = this.el.querySelectorAll('.testimonies__content__data__title')
    const texts = this.el.querySelectorAll('.testimonies__content__data__text')
    const names = this.el.querySelectorAll('.testimonies__content__data__name')
    const testimonies = []

    for (let i = 0; i < medias.length; i++) {
      testimonies.push({
        media: medias[i],
        title: titles[i],
        text: texts[i],
        name: names[i]
      })
    }

    return testimonies
  }

  clickedPrev() {
    this.goTo(this.currentIndex - 1)
  }

  clickedNext() {
    this.goTo(this.currentIndex + 1)
  }

  clickedTitle({ target }) {
    const index = this.testimonies.findIndex(testimony => testimony.title === target)

    if (index !== -1)
      this.goTo(index)
  }

  goTo(index) {
    if (index < 0 || index > this.maxIndex || index === this.currentIndex || this.isTransitioning)
      return

    this.isTransitioning = true

    this.prevBtn.disabled = index === 0
    this.nextBtn.disabled = index === this.testimonies.length - 1

    const oldTestimony = this.testimonies[this.currentIndex]
    const newTestimony = this.testimonies[index]

    const onTransitionEnd = ({ propertyName }) => {
      if (propertyName === 'opacity')
        return

      oldTestimony.media.removeEventListener('transitionend', onTransitionEnd)

      newTestimony.media.classList.add('is-active')
      newTestimony.title.classList.add('is-active')
      newTestimony.text.classList.add('is-active')
      newTestimony.name.classList.add('is-active')

      this.currentIndex = index
      this.isTransitioning = false
      this.currentTransitionEndCallback = null
    }

    this.currentTransitionEndCallback = onTransitionEnd
    oldTestimony.media.addEventListener('transitionend', onTransitionEnd)

    oldTestimony.media.classList.remove('is-active')
    oldTestimony.title.classList.remove('is-active')
    oldTestimony.text.classList.remove('is-active')
    oldTestimony.name.classList.remove('is-active')

    this.refreshTitleOffset(index)
  }

  refreshTitleOffset(index = this.currentIndex) {
    const title = this.testimonies[index].title
    const titleOffsetLeft = title.offsetLeft

    this.titlesWrapper.style.setProperty('--title-offset', `${titleOffsetLeft}px`)
  }

  destroy() {
    this.titlesWrapper.removeEventListener('focusin', this.onFocusInTitlesWrapper)
    this.titlesWrapper.removeEventListener('focusout', this.onFocusOutTitlesWrapper)

    if (this.currentTransitionEndCallback) {
      for (const testimony of this.testimonies) {
        testimony.media.removeEventListener('transitionend', this.currentTransitionEndCallback)
      }

      this.currentTransitionEndCallback = null
    }

    this.ro.disconnect()
  }
}
